import {useState} from 'react'
import {
  Tab, TabPane, Card, Mask, Text, TextButton, Loading
} from '@binance/uikit'
import useUserLoginStatus from 'hooks/useUserLoginStatus'
import useRouter from 'hooks/useRouter'
import useSymbolInfo from 'hooks/useSymbolInfo'
import useOpenOrders from 'hooks/useOpenOrders'
import {LOGIN_PRURL, REGISTER_URL, isTestnet} from 'constants'
import PositionPane from './PositionPane'
import MarginBalancePane from './MarginBalancePane'
import APIKEYPane from './APIKEYPane'
import OpenOrdersPane from './OpenOrdersPane'
import OrderHistoryPane from './OrderHistoryPane'
import TradeHistoryPane from './TradeHistoryPane'
import TransactionHistoryPane from './TransactionHistoryPane'

export default function HistoryView ({i18n}) {
  const isLogin = useUserLoginStatus()
  const [focus, setFocus] = useState(0)
  const router = useRouter()
  const {lng = 'en'} = router.query
  const {symbolInfo} = useSymbolInfo()
  const {openOrders} = useOpenOrders(symbolInfo)
  const ordersLen = openOrders?.length || 0
  const ordersNum = ordersLen > 0 ? ` (${ordersLen})` : ''

  return (
    <Card gridArea="history" className="trade-history">
      {isLogin === false && (
        <Mask>
          <Text.Base>{i18n.please || 'Please'}</Text.Base>
          <TextButton
            onClick={() => {
              window.location.href = `${LOGIN_PRURL}?callback=${window.location.href}`.replace(
                '$locale',
                lng
              )
            }}
            color="#F0B90B"
            mr={2}
          >
            {i18n['tradeHistory-login'] || 'Log in'}
          </TextButton>
          <Text.Base>{i18n.or || 'or'}</Text.Base>
          <TextButton
            onClick={() => (window.location.href = REGISTER_URL.replace('$locale', lng))}
            color="#F0B90B"
          >
            {i18n['tradeHistory-register'] || 'Register now'}
          </TextButton>
        </Mask>
      )}
      {isLogin === undefined && (
        <Mask>
          <Loading width="50px" />
        </Mask>
      )}
      <Tab
        handleTabChange={tab => {
          setFocus(tab)
        }}
        style={{zIndex: 0}}
      >
        <TabPane label={i18n['tradeHistory-positionsLabel'] || 'Positions'} className="position-tab">
          <PositionPane i18n={i18n} />
        </TabPane>
        <TabPane label={i18n['tradeHistory-marginBalanceLabel'] || 'Margin Balance'}>
          <MarginBalancePane i18n={i18n} />
        </TabPane>
        <TabPane label={`${i18n['tradeHistory-openOrdersLabel'] || 'Open Orders'}${ordersNum}`}>
          <OpenOrdersPane i18n={i18n} />
        </TabPane>
        <TabPane label={i18n['tradeHistory-orderHistoryLabel'] || 'Order History'}>
          <OrderHistoryPane i18n={i18n} focus={focus === 3} />
        </TabPane>
        <TabPane label={i18n['tradeHistory-tradeHistoryLabel'] || 'Trade History'}>
          <TradeHistoryPane i18n={i18n} focus={focus === 4} />
        </TabPane>
        <TabPane label={i18n['tradeHistory-transactionHistoryLabel'] || 'Transaction History'}>
          <TransactionHistoryPane i18n={i18n} focus={focus === 5} />
        </TabPane>
        {isTestnet && (
          <TabPane label={i18n['tradeHistory-APIKeyLabel'] || 'API Key'}>
            <APIKEYPane i18n={i18n} />
          </TabPane>
        )}
      </Tab>
    </Card>
  )
}
